import React from 'react';
export const BlockSpaces = ({ spaces }) => {
    if (spaces) {
        const arreglo = [];
        for (let i = 0; i < spaces; i++) {
            arreglo.push(i);
        }
        return (React.createElement("div", null, arreglo.map(value => (React.createElement(Space, { key: value })))));
    }
    else {
        return React.createElement(Space, null);
    }
};
const Space = () => (React.createElement("div", { style: { height: '10px' } }, '\n'));



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockSpaces.tsx
// module id = 108
// module chunks = 0